export const HEARTS = [
    {
        id: 0,
        wishid: 0,
        heartsval: 48,
        lastheart: "Nov 1, 2020"
    },
    {
        id: 1,
        wishid: 1,
        heartsval: 36,
        lastheart: "Nov 2, 2020"
    },

    {
        id: 2,
        wishid: 2,
        heartsval: 15,
        lastheart: "Nov 3, 2020"
    },
    {
        id: 3,
        wishid: 3,
        heartsval: 4,
        lastheart: "Nov 4, 2020"
    },
    {
        id: 4,
        wishid: 4,
        heartsval: 27,
        lastheart: "Nov 1, 2020"
    },
    {
        id: 5,
        wishid: 5,
        heartsval: 10,
        lastheart: "Nov 2, 2020"
    },
    {
        id: 6,
        wishid: 6,
        heartsval: 2,
        lastheart: "Nov 3, 2020"
    },
    {
        id: 7,
        wishid: 7,
        heartsval: 8,
        lastheart: "Nov 4, 2020"
    },
    {
        id: 8,
        wishid: 8,
        heartsval: 21,
        lastheart: "Nov 5, 2020"
    },
    {
        id: 9,
        wishid: 9,
        heartsval: 17,
        lastheart: "Nov 6, 2020"
    },
    {
        id: 10,
        wishid: 10,
        heartsval: 12,
        lastheart: "Nov 5, 2020"
    },
]